<template>
  <div class="col-sm-12 stock-adjustment-page">
    <div class="card stock-adjustment-card">
      <!-- Top Bar -->
      <div class="adjustment-topbar">
        <div class="search-box">
          <input
            type="text"
            placeholder="Search item by name"
            class="search-input"
            v-model="searchFilter"
          />
        </div>

        <div class="item-count-pill">{{ filteredItems.length }} Items</div>
      </div>

      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <!-- Items Table -->
      <div v-if="itemList.length > 0" class="table-frame">
        <div class="table-scroll-shell">
          <table class="table adjustment-table">
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Normal<br />Current Qty</th>
                <th>Adjust Type</th>
                <th>Adjust Qty</th>
                <th>Reason</th>
                <th>Damaged<br />Current Qty</th>
                <th>Damaged<br />Adjust Type</th>
                <th>Damaged<br />Adjust Qty</th>
                <th>Damage<br />Reason</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="item in filteredItems" :key="item.item_id || item.id">
                <td class="item-name">
                  {{ item.item_name }}
                </td>

                <td>
                  <span class="qty-pill normal">
                    {{ item.normal_current_qty }}
                  </span>
                </td>

                <td>
                  <div class="adjust-switch">
                    <button
                      type="button"
                      :class="[
                        'adjust-btn',
                        item.normal_adjust_type === '+' ? 'active-plus' : '',
                      ]"
                      @click="setAdjustType(item, '+', 'normal')"
                    >
                      +
                    </button>

                    <button
                      type="button"
                      :class="[
                        'adjust-btn',
                        item.normal_adjust_type === '-' ? 'active-minus' : '',
                      ]"
                      @click="setAdjustType(item, '-', 'normal')"
                    >
                      -
                    </button>
                  </div>
                </td>

                <td>
                  <input
                    type="number"
                    min="0"
                    class="qty-input"
                    :class="{
                      'input-error':
                        item.normal_adjust_type === '-' &&
                        item.normal_adjust_value > item.normal_current_qty,
                    }"
                    v-model.number="item.normal_adjust_value"
                    @input="clampQty(item, 'normal')"
                  />

                  <span
                    v-if="
                      item.normal_adjust_type === '-' &&
                      item.normal_adjust_value > item.normal_current_qty
                    "
                    class="qty-error-msg"
                  >
                    Max: {{ item.normal_current_qty }}
                  </span>
                </td>

                <td>
                  <select v-model="item.reason_id" class="select-reason">
                    <option value="">Select Reason</option>
                    <option
                      v-for="reason in reasons"
                      :key="reason.id"
                      :value="reason.id"
                    >
                      {{ reason.reason_name }}
                    </option>
                  </select>
                </td>

                <td>
                  <span class="qty-pill damaged">
                    {{ formatWholeQty(item.damaged_current_qty) }}
                  </span>
                </td>

                <td>
                  <div class="adjust-switch">
                    <button
                      type="button"
                      :class="[
                        'adjust-btn',
                        item.damaged_adjust_type === '+' ? 'active-plus' : '',
                      ]"
                      @click="setAdjustType(item, '+', 'damaged')"
                    >
                      +
                    </button>

                    <button
                      type="button"
                      :class="[
                        'adjust-btn',
                        item.damaged_adjust_type === '-' ? 'active-minus' : '',
                      ]"
                      @click="setAdjustType(item, '-', 'damaged')"
                    >
                      -
                    </button>
                  </div>
                </td>

                <td>
                  <input
                    type="number"
                    min="0"
                    class="qty-input"
                    :class="{
                      'input-error':
                        item.damaged_adjust_type === '-' &&
                        item.damaged_adjust_value > item.damaged_current_qty,
                    }"
                    v-model.number="item.damaged_adjust_value"
                    @input="clampQty(item, 'damaged')"
                  />

                  <span
                    v-if="
                      item.damaged_adjust_type === '-' &&
                      item.damaged_adjust_value > item.damaged_current_qty
                    "
                    class="qty-error-msg"
                  >
                    Max: {{ formatWholeQty(item.damaged_current_qty) }}
                  </span>
                </td>

                <td>
                  <select v-model="item.damage_reason_id" class="select-reason">
                    <option value="">Select Damage Reason</option>
                    <option
                      v-for="reason in reasons"
                      :key="reason.id"
                      :value="reason.id"
                    >
                      {{ reason.reason_name }}
                    </option>
                  </select>
                </td>
              </tr>

              <tr v-if="filteredItems.length === 0">
                <td colspan="9" class="text-center empty-row">
                  No items found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else-if="!loading" class="no-data-message">
        No items available.
      </div>

       <!-- Compact Bottom Action Bar -->
    <div class="compact-save-bar">
      <div class="comment-inline">
        <span class="comment-label">Comment</span>

        <input
          type="text"
          placeholder="Enter comment..."
          class="comment-input"
          v-model="comment"
        />
      </div>

      <button
        type="button"
        class="btn button-default save-adjustment-btn"
        @click="submitAdjustment"
        :disabled="loading"
      >
        <span v-if="loading" class="spinner-border spinner-border-sm"></span>
        <span v-else>Save Adjustment</span>
      </button>
    </div>
    </div>

   
  </div>
</template>

<script>
import {
  fetchDistributorStockList,
  saveStockAdjustment,
  fetchAdjustmentReasons,
} from "@/services/dataService";
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      loading: false,
      token: localStorage.getItem("token_set"),
      profile_id: localStorage.getItem("profile_id"),
      comment: "",
      searchFilter: "",
      itemList: [],
      distributorId: null,
      reasons: [],
    };
  },

  computed: {
    filteredItems() {
      return this.itemList.filter((item) =>
        (item.item_name || "")
          .toLowerCase()
          .includes(this.searchFilter.toLowerCase()),
      );
    },
  },

  mounted() {
    this.getItems();
    this.getReasons();
  },

  methods: {
    async getItems() {
      try {
        this.loading = true;

        const response = await fetchDistributorStockList(
          this.profile_id,
          this.token,
        );

        this.distributorId = response.data?.distributor_id;

        this.itemList = (response.data?.data || []).map((item) => ({
          ...item,
          normal_current_qty: item.current_normal_qty || 0,
          damaged_current_qty: item.current_damaged_qty || 0,
          normal_adjust_type: "+",
          normal_adjust_value: 0,
          damaged_adjust_type: "+",
          damaged_adjust_value: 0,
          reason_id: "",
          damage_reason_id: "",
        }));
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        this.loading = false;
      }
    },

    async getReasons() {
      try {
        const response = await fetchAdjustmentReasons(this.token);
        this.reasons = response.data?.data || [];
      } catch (error) {
        console.error("Error fetching adjustment reasons:", error);
      }
    },

    setAdjustType(item, type, stockType = "normal") {
      if (stockType === "normal") {
        item.normal_adjust_type = type;
        this.clampQty(item, "normal");
      } else if (stockType === "damaged") {
        item.damaged_adjust_type = type;
        this.clampQty(item, "damaged");
      }
    },

    clampQty(item, stockType) {
      if (stockType === "normal") {
        if (
          item.normal_adjust_type === "-" &&
          item.normal_adjust_value > item.normal_current_qty
        ) {
          item.normal_adjust_value = item.normal_current_qty;
        }

        if (item.normal_adjust_value < 0) {
          item.normal_adjust_value = 0;
        }
      } else if (stockType === "damaged") {
        if (
          item.damaged_adjust_type === "-" &&
          item.damaged_adjust_value > item.damaged_current_qty
        ) {
          item.damaged_adjust_value = item.damaged_current_qty;
        }

        if (item.damaged_adjust_value < 0) {
          item.damaged_adjust_value = 0;
        }
      }
    },

    formatWholeQty(value) {
      const numberValue = Number(value);

      if (!Number.isFinite(numberValue)) {
        return 0;
      }

      return Math.trunc(numberValue);
    },

    async submitAdjustment() {
      const toast = useToast();

      const adjustedItems = this.itemList
        .filter(
          (item) =>
            item.normal_adjust_value > 0 || item.damaged_adjust_value > 0,
        )
        .map((item) => ({
          distributor_id: this.distributorId,
          item_id: item.item_id,
          reason_id: item.reason_id,
          damage_reason_id: item.damage_reason_id,
          normal_adjust_qty:
            item.normal_adjust_type === "+"
              ? item.normal_adjust_value
              : -item.normal_adjust_value,
          damaged_adjust_qty:
            item.damaged_adjust_type === "+"
              ? item.damaged_adjust_value
              : -item.damaged_adjust_value,
        }));

      if (!this.comment || !this.comment.trim()) {
        toast.error("Comment is required");
        return;
      }

      if (adjustedItems.length === 0) {
        toast.error("No adjustments made");
        return;
      }

      const invalidItems = this.itemList.filter(
        (item) =>
          (item.normal_adjust_type === "-" &&
            item.normal_adjust_value > item.normal_current_qty) ||
          (item.damaged_adjust_type === "-" &&
            item.damaged_adjust_value > item.damaged_current_qty),
      );

      if (invalidItems.length > 0) {
        toast.error(
          `Adjustment qty cannot exceed current qty for: ${invalidItems
            .map((i) => i.item_name)
            .join(", ")}`,
        );
        return;
      }

      const payload = {
        created_by: this.profile_id,
        comment: this.comment.trim(),
        items: adjustedItems,
      };

      console.log("Payload to send:", payload);

      this.loading = true;

      try {
        const response = await saveStockAdjustment(payload, this.token);

        if (response.data.status === "success") {
          toast.success(response.data.message);
          this.comment = "";
          this.searchFilter = "";
          await this.getItems();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast(error.response.data.message, { type: "error" });
        } else {
          toast("Error saving initial stock", { type: "error" });
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.stock-adjustment-page {
  padding-bottom: 14px;
}

/* Main Card */
.stock-adjustment-card {
  padding: 0;
  overflow: hidden;
  border: 1px solid #e8edf3;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
}

/* Top Search Area */
.adjustment-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border-bottom: 1px solid #edf1f6;
  background: #fbfcfe;
}

.search-box {
  width: 100%;
  max-width: 380px;
}

.search-input {
  width: 100%;
  height: 36px;
  padding: 7px 12px;
  border: 1px solid #d6deea;
  border-radius: 8px;
  background: #ffffff;
  color: #1f2937;
  font-size: 13px;
  transition: all 0.2s ease;
}

.item-count-pill {
  flex-shrink: 0;
  padding: 6px 12px;
  border: 1px solid #dde7f3;
  border-radius: 999px;
  background: #f4f8fd;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

/* Table Area */
.table-frame {
  padding: 10px;
}

.table-scroll-shell {
  max-height: 455px;
  overflow: auto;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  background: #ffffff;
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.45) transparent;
}

/* Premium tiny scrollbars */
.table-scroll-shell::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.table-scroll-shell::-webkit-scrollbar-track {
  background: transparent;
}

.table-scroll-shell::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(100, 116, 139, 0.38);
}

.table-scroll-shell::-webkit-scrollbar-thumb:hover {
  background: rgba(51, 65, 85, 0.55);
}

.adjustment-table {
  min-width: 1120px;
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
  color: #1f2937;
}

.adjustment-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 10px 10px;
  border-bottom: 1px solid #dfe7f1;
  background: #f7f9fc;
  color: #475569;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.25;
  text-transform: uppercase;
  white-space: nowrap;
  vertical-align: middle;
}

.adjustment-table tbody td {
  padding: 9px 10px;
  border-bottom: 1px solid #edf1f6;
  background: #ffffff;
  color: #334155;
  font-size: 12.5px;
  vertical-align: middle;
}

.adjustment-table tbody tr:hover td {
  background: #fbfdff;
}

.adjustment-table tbody tr:last-child td {
  border-bottom: 0;
}

.item-name {
  min-width: 180px;
  color: #111827;
  font-weight: 700;
}

.qty-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 46px;
  height: 26px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

.qty-pill.normal {
  background: #eff6ff;
  color: #1d4ed8;
}

.qty-pill.damaged {
  background: #fff1f2;
  color: #be123c;
}

/* Plus Minus Buttons */
.adjust-switch {
  display: inline-flex;
  gap: 4px;
  padding: 3px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.adjust-btn {
  width: 28px;
  height: 26px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 6px;
  background: #ffffff;
  color: #64748b;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
  transition: all 0.18s ease;
}

.adjust-btn:hover {
  border-color: #cbd5e1;
  color: #1e293b;
}

.active-plus {
  background-color: #16a34a;
  color: #ffffff;
}

.active-minus {
  background-color: #dc2626;
  color: #ffffff;
}

/* Inputs */
.qty-input {
  width: 78px;
  height: 32px;
  padding: 5px 8px;
  border: 1px solid #d6deea;
  border-radius: 7px;
  background: #ffffff;
  color: #1f2937;
  font-size: 12.5px;
  transition: all 0.2s ease;
}

.select-reason {
  width: 100%;
  min-width: 175px;
  height: 32px;
  padding: 5px 8px;
  border: 1px solid #d6deea;
  border-radius: 7px;
  background: #ffffff;
  color: #1f2937;
  font-size: 12.5px;
  transition: all 0.2s ease;
}

.search-input:focus,
.comment-input:focus,
.qty-input:focus,
.select-reason:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
  outline: none;
}

.input-error {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.12) !important;
}

.qty-error-msg {
  display: block;
  margin-top: 3px;
  color: #dc3545;
  font-size: 10.5px;
  font-weight: 700;
}

/* Compact Bottom Save Bar */
.compact-save-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
  padding: 8px 10px;
  border: 1px solid #e7edf5;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.045);
}

.comment-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(100%, 430px);
}

.comment-label {
  flex-shrink: 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.comment-input {
  width: 100%;
  height: 34px;
  padding: 6px 10px;
  border: 1px solid #d6deea;
  border-radius: 8px;
  background: #ffffff;
  color: #1f2937;
  font-size: 12.5px;
  transition: all 0.2s ease;
}

.save-adjustment-btn {
  min-width: 132px;
  height: 34px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 800;
  white-space: nowrap;
}

.button-default {
  color: #ffffff;
  background-color: #2563eb;
  border-color: #2563eb;
}

.button-default:hover {
  color: #ffffff;
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}

.button-default:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

/* States */
.loading-spinner {
  padding: 22px;
  color: #2563eb;
  font-size: 15px;
  text-align: center;
}

.no-data-message {
  padding: 24px;
  color: #6c757d;
  font-style: italic;
  text-align: center;
}

.empty-row {
  padding: 20px !important;
  color: #64748b !important;
  font-style: italic;
  text-align: center;
}

.text-center {
  text-align: center;
}

/* Existing icon styles */
.fa-eye,
.fa-edit,
.fa-shield {
  margin-left: 5px;
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}

i:hover {
  color: #0056b3;
  transform: scale(1.2);
}

i:active {
  transform: scale(1.1);
}

.action-icon {
  margin-right: 10px;
}

.status-label {
  display: inline-block;
  min-width: 90px;
  max-width: 90px;
  padding: 4px 12px;
  border-radius: 5px;
  font-size: 0.75rem;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-yes {
  background-color: #069e27;
  color: #ffffff;
  border-radius: 4px;
}

.status-no {
  background-color: red;
  color: #ffffff;
  border-radius: 4px;
}

.scrollable-dropdown {
  max-height: 200px;
  overflow-y: auto;
}

/* Tablet */
@media (max-width: 992px) {
  .adjustment-topbar {
    align-items: stretch;
    flex-direction: column;
  }

  .search-box {
    max-width: 100%;
  }

  .item-count-pill {
    width: fit-content;
  }

  .compact-save-bar {
    align-items: stretch;
    flex-direction: column;
  }

  .comment-inline {
    width: 100%;
  }

  .save-adjustment-btn {
    width: 100%;
  }
}

/* Mobile */
@media (max-width: 576px) {
  .table-frame {
    padding: 8px;
  }

  .adjustment-topbar {
    padding: 10px;
  }

  .compact-save-bar {
    padding: 9px;
  }

  .comment-inline {
    align-items: stretch;
    flex-direction: column;
    gap: 5px;
  }

  .comment-label {
    font-size: 11.5px;
  }

  .adjustment-table {
    min-width: 1040px;
  }

  .adjustment-table thead th,
  .adjustment-table tbody td {
    padding: 8px;
  }

  .select-reason {
    min-width: 160px;
  }
}
</style>
